import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import {
  VIEW_GENDER_QUERY_KEY,
  genderService,
} from "../../../../Services/genderService";
import { ViewGender } from "../../../../Types/MasterData/Gender";
import FilterComponent from "../../Common/FilterComponent";
import DataTable from "react-data-table-component";
import { GenderTableColumn } from "../../../../Data/DataTables/Gender";

const GenderTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_GENDER_QUERY_KEY,
    queryFn: genderService.getAllViewGender,
  });
  const filteredItems: ViewGender[] = usersResponse?.data.filter(
    (item: ViewGender) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={GenderTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default GenderTable;
